<!--<body> -->
<div class="background">
  <div class="container main-container login-large-scr">
    <!-- PAGE TITLE AND DESCRIPTION -->
    <div class="container-lg">
      <p class="sentens mobile-margin description">
        <span>
          {{ title }}
        </span>
      </p>
      <!-- DESCRIPTION -->
      <div [ngbCollapse]="isCollapsed" id="collapseDescription">
        <div class="mobile-margin card">
          <p class="sentens description">
            <span>
              {{ description }}
            </span>
          </p>
          <p class="sentens description">
            <span>
              {{ footer }}
            </span>
            <strong>
              &nbsp;
              <a [href]="'http://' + website" target="_blank">{{ website }}</a>
            </strong>
          </p>
        </div>
      </div>
      <p class="sentens">
        <a
          class="btn description-btn dropdown-toggle show-more description"
          (click)="isCollapsed = !isCollapsed"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="collapseDescription"
        >
          {{ isCollapsed == true ? 'Read more ' : 'Show less ' }}
        </a>
      </p>
    </div>
    <!-- TITLE -->
    <div class="container login-container">
      <h1 class="member-login">{{ 'LOGIN.LOGIN-TITLE' | translate }}</h1>
      <form id="loginForm" class="form-container">
        <div class="row login-container">
          <div class="col-md-6 offset-md-0 login-field">
            <input
              id="username"
              name="username"
              type="text"
              placeholder="{{ 'LOGIN.PLACEHOLDER-USERNAME' | translate }}"
              class="form-control"
              [(ngModel)]="username"
              (keyup.enter)="login()"
              id="user"
            />
          </div>

          <div class="col-md-6 offset-md-0">
            <input
              id="password"
              name="password"
              type="password"
              placeholder="{{ 'LOGIN.PLACEHOLDER-PASSWORD' | translate }}"
              class="form-control"
              [(ngModel)]="password"
              (keyup.enter)="login()"
            />
          </div>
        </div>

        <div [ngSwitch]="loginStatus" id="response-message">
          <span
            *ngSwitchCase="Status.INVALID_CREDENTIALS"
            class="error font-weight-normal incorrectMessage"
          >
            <span>
              {{ 'LOGIN.INCORRECT-USERNAME-PASSWORD' | translate }}
            </span>
          </span>
          <span
            *ngSwitchCase="Status.ERROR"
            class="error font-weight-normal incorrectMessage"
          >
            <br />{{ 'LOGIN.ERROR' | translate }}
          </span>
          <span
            *ngSwitchCase="Status.SUCCESS"
            class="success font-weight-normal"
          >
            {{ 'LOGIN.SUCCESSFUL' | translate }}
          </span>
          <span
            *ngSwitchCase="Status.BLOCKED"
            class="error font-weight-normal incorrectMessage"
          >
            {{ 'LOGIN.ACCOUNT_BLOCKED' | translate }}
            <span class="email">
              <a href="'mailto:'+ {{ 'LOGIN.SUPPORT_EMAIL' | translate }}">
                {{ 'LOGIN.SUPPORT_EMAIL' | translate }}
              </a>
              <br />
            </span>
          </span>
          <span
            *ngSwitchCase="Status.PASSWORD_RESET"
            class="error font-weight-normal sentens incorrectMessage"
          >
            {{ 'LOGIN.PASSWORD-RESET' | translate }}
          </span>

          <span
            *ngSwitchCase="Status.WAITING"
            class="success font-weight-normal sentens"
          >
            {{ 'LOGIN.WAITING' | translate }}
          </span>
        </div>
      </form>

      <div class="row">
        <div class="col-12 mobile-item-space">
          <button
            id="loginButton"
            type="button"
            (click)="login()"
            class="btn btn-primary btn-lg raised col-6 offset-3 col-lg-2 offset-lg-0 login-button"
            type="submit"
          >
            <div *ngIf="knowActionOuterParam; else simpleLogin">
              <p
                *ngIf="outerParam.action === this.ACTION_CONFIRM"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-CONFIRM' | translate }}
              </p>
              <p
                *ngIf="outerParam.action === this.ACTION_DENY"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-DENY' | translate }}
              </p>
              <p
                *ngIf="outerParam.action === this.ACTION_BID"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-GO-BID' | translate }}
              </p>
              <p
                *ngIf="outerParam.action === this.ACTION_BID_LIST"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-GO-BID-LIST' | translate }}
              </p>
              <p
                *ngIf="outerParam.action === this.ACTION_CARRIER_CERTIFICATE"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-GO-CARRIER-PROFILE' | translate }}
              </p>
              <p
                *ngIf="outerParam.action === this.ACTION_ORDER"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-GO-ORDER' | translate }}
              </p>
              <p
                *ngIf="outerParam.action === this.ACTION_ORDER_LIST"
                class="font-weight-bolder login-button-txt text-center"
              >
                {{ 'LOGIN.BUTTON-LOGIN-AND-GO-ORDER-LIST' | translate }}
              </p>
            </div>
            <ng-template #simpleLogin>
              <p
                class="font-weight-bolder login-button-txt text-center login-text"
              >
                {{ 'LOGIN.BUTTON-LOGIN' | translate }}
              </p>
            </ng-template>
            <img
              class="arrow text-center login-arrow"
              src="../../../assets/login/right-arrow.png"
              alt=""
            />
          </button>
          <small
            *ngIf="!!outerParam && outerParam.action === this.ACTION_CONFIRM"
            class="login-failure"
          >
            {{ 'LOGIN.WARNING-LOGIN-AND-CONFIRM' | translate }}
          </small>
          <small
            *ngIf="!!outerParam && outerParam.action === this.ACTION_DENY"
            class="login-failure"
          >
            {{ 'LOGIN.WARNING-LOGIN-AND-DENY' | translate }}
          </small>
          <small
            *ngIf="!!outerParam && outerParam.action === this.ACTION_BID"
            class="login-failure"
          >
            {{ 'LOGIN.WARNING-LOGIN-AND-GO-BID' | translate }}
          </small>
          <small
            *ngIf="!!outerParam && outerParam.action === this.ACTION_BID_LIST"
            class="login-failure"
          >
            {{ 'LOGIN.WARNING-LOGIN-AND-GO-BID-LIST' | translate }}
          </small>
          <small
            *ngIf="
              !!outerParam &&
              outerParam.action === this.ACTION_CARRIER_CERTIFICATE
            "
            class="login-failure"
          >
            {{
              'LOGIN.WARNING-LOGIN-AND-GO-CARRIER-PROFILE' | translate
            }} </small
          ><small
            *ngIf="!!outerParam && outerParam.action === this.ACTION_ORDER"
            class="login-failure"
          >
            {{ 'LOGIN.WARNING-LOGIN-AND-GO-ORDER' | translate }}
          </small>
          <small
            *ngIf="!!outerParam && outerParam.action === this.ACTION_ORDER_LIST"
            class="login-failure"
          >
            {{ 'LOGIN.WARNING-LOGIN-AND-GO-ORDER-LIST' | translate }}
          </small>
        </div>
      </div>
      <div class="row mobile-item-space">
        <div class="col-12 item-mobile-left">
          <p class="forgot">
            <a
              id="forgottenPassword"
              [routerLink]="['/reset-password']"
              class="font-weight-normal"
            >
              {{ 'LOGIN.FORGOT-PASSWORD' | translate }}
            </a>
          </p>
        </div>
        <div class="col-12 item-mobile-left">
          <p
            class="font-weight-normal"
            style="font-size: 14px"
            id="register-here"
          >
            {{ 'LOGIN.DONT-HAVE-ACCOUNT' | translate }}
            <a
              id="createAccount"
              [routerLink]="['/register']"
              class="font-weight-normal register"
              >{{ 'LOGIN.REGISTER' | translate }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
